import ActivityIndicator from "@components/shared/ActivityIndicator/ActivityIndicator";
import OwButton from "@components/shared/OwButton/OwButton";
import OwLabel from "@components/shared/OwLabel/OwLabel";
import OwSelectOption from "@components/shared/OwSelectOption/OwSelectOption";
import { SocketContext } from "@contexts/SocketContext";
import SupplierContext from "@contexts/SupplierContext";
import UserContext from "@contexts/UserContext";
import ISquareCreateDeviceCodeDTO from "@models/DTO/ISquareCreateDeviceCodeDTO";
import ISquareGetConnectedTerminalsDTO from "@models/DTO/ISquareGetConnectedTerminalsDTO";
import ISquareGetDevicesDTO from "@models/DTO/ISquareGetDevicesDTO";
import ISquareGetLocationsDTO from "@models/DTO/ISquareGetLocationsDTO";
import ISquareOnCreateDeviceCodeDTO from "@models/DTO/ISquareOnCreateDeviceCodeDTO";
import ISquareOnGetConnectedTerminalsDTO from "@models/DTO/ISquareOnGetConnectedTerminalsDTO";
import ISquareOnGetDevicesDTO from "@models/DTO/ISquareOnGetDevicesDTO";
import ISquareOnGetLocationsDTO from "@models/DTO/ISquareOnGetLocationsDTO";
import ISquareOnSendOrderTotalToSquareTerminalDTO from "@models/DTO/ISquareOnSendOrderTotalToSquareTerminalDTO";
import ISquareSendOrderTotalToSquareTerminalDTO from "@models/DTO/ISquareSendOrderTotalToSquareTerminalDTO";
import EndpointsEnum from "@models/EndpointsEnum";
import IOrder from "@models/IOrder";
import ISquare_Terminal from "@models/ISquare_Terminal";
import IUiSocketSetup from "@models/IUiSocketSetup";
import HelperService from "@services/HelperService";
import SocketService from "@services/SocketService";
import UIService from "@services/UIService";
import { useContext, useEffect, useState } from "react";
import {Square} from "square";

type Props = {
    orderModel: IOrder;
    cancelFn: (refresh?: boolean) => void;
    confirmFn: (refresh?: boolean) => void;
};

export const OrderPaymentSquareTerminal = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;

    const onSendOrderTotalToSquareTerminal = (data: ISquareOnSendOrderTotalToSquareTerminalDTO) => {
        setPaymentRequestSent(true);
    }

    const onGetTerminals = (data: ISquareOnGetConnectedTerminalsDTO) => {
        setDevices(data.terminals);

        setIsLoading(false);
    }

    const sockets: IUiSocketSetup[] = [
        {endpoint: EndpointsEnum.SquareOnGetConnectedTerminals, fn: onGetTerminals},
        {endpoint: EndpointsEnum.SquareOnSendOrderTotalToSquareTerminal, fn: onSendOrderTotalToSquareTerminal},
    ];

    const [paymentRequestSent, setPaymentRequestSent] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [devices, setDevices] = useState<ISquare_Terminal[]>([]);
    const [selectedDevice, setSelectedDevice] = useState<ISquare_Terminal | null>(null);

    const getTerminals = () => {
        const payload: ISquareGetConnectedTerminalsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        }

        socket.emit(EndpointsEnum.SquareGetConnectedTerminals, payload);

        setIsLoading(true);
    }

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        getTerminals();

        return () => {
            for (const _socket of sockets) {
                socket.off(_socket.endpoint, _socket.fn);
            }
        }
    }, [] );

    const selectDevice = (device: ISquare_Terminal) => {
        setSelectedDevice(device);
    }

    const sendPaymentRequest = () => {
        if (selectedDevice?.id) {
            const payload: ISquareSendOrderTotalToSquareTerminalDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                orderGuid: props.orderModel.guid,
                terminalId: selectedDevice.id,
            }

            socket.emit(EndpointsEnum.SquareSendOrderTotalToSquareTerminal, payload);
        }
        
    }

    return <div className={"OrderPaymentSquareTerminal"}>
        {isLoading ? <div className="text-center"><ActivityIndicator active={isLoading} /><OwLabel title="loading" /></div> : 
        <div>
            <div className="mt-2 mb-4">
                <OwLabel title="select_terminal" />
                <OwSelectOption 
                    valueProp="id"
                    titleProp="name"
                    fn={selectDevice}
                    name="device"
                    options={devices}
                    emitObject={true}
                />
            </div>

            {!devices.length ? <div><OwLabel title="no_terminals_found" className="me-2"/><a href={`${SocketService.getStaticSiteUrl()}/learn/square-getting-started`} target="_blank" rel="noreferrer"><OwLabel title="learn_more" className="pointer" /></a></div> : null}

            <div>
                <OwButton title="send_payment_request" fn={sendPaymentRequest}/>
            </div>

            {paymentRequestSent ? <div className="mt-4"><div><OwLabel title="payment_request_sent" isBold={true}/></div><div><OwLabel title="awaiting_completed_payment_response"/></div><div className="mt-2"><OwButton title="return_to_order" fn={() => {props.cancelFn(true) }}/></div></div> : null}
        </div>}
    </div>;
};
